import { lazyWithPreload } from '@/utils/lazyWithPreload';

export const LazyProfilePage = lazyWithPreload(() => import('@/pages/ProfileDetailsPage'));
export const LazyAdminUsersPage = lazyWithPreload(() => import('@/pages/AdminUsersPage'));
export const LazyMyTasksPage = lazyWithPreload(() => import('@/pages/MyTasksPage'));
export const LazyMyClaimsPage = lazyWithPreload(() => import('@/pages/MyClaimsPage'));
export const LazyClaimSetPage = lazyWithPreload(() => import('@/pages/ClaimSetPage'));
export const LazyErrorPage = lazyWithPreload(() => import('@/pages/ErrorPage'));
export const LazyPartyDetailsPage = lazyWithPreload(() => import('@/pages/PartyDetailsPage'));
